export default {
  ERR_ARGUMENTS: 'ERR_ARGUMENTS',
  COMPRESS_FAIL: 'COMPRESS_FAIL',
  DROPBOX_AUTH_FAIL: 'DROPBOX_AUTH_FAIL',
}